module.exports = __webpack_public_path__ + "static/img/story_HugTeach.12071ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/story_HugTeach.png
// module id = S76E
// module chunks = 1